import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useGoogleAnalyticsConnection } from '@modules/Dashboard/pages/Analytics/pages/AnalyticsOverview/modules/GoogleAnalytics'

import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import googleAnalytics from '../assets/google-analytics.png'

export const useGoogleAnalyticsRecommendation = () => {
  const { connectLink, status, isLoading } = useGoogleAnalyticsConnection()
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()

  return {
    googleAnalyticsRecommendation: {
      id: 'googleAnalytics',
      enabled: recommendationsDismiss.googleAnalytics.visible && status === 'NOT_CONNECTED',
      isLoading,
      suggestion: (
        <Suggestion
          title="See views and other advanced stats with Google Analytics"
          description="Access views, demographics, traffic sources, and other advanced analytics."
          imageUrl={googleAnalytics}
          buttonLabel="Connect to Google Analytics"
          buttonHref={connectLink}
          buttonTarget="_blank"
          analytics="googleAnalytics"
          onDismiss={createOnDismiss(recommendationsDismiss.googleAnalytics.dismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
